module.exports = __webpack_public_path__ + "static/wordtree.a1cbbaf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Title/wordtree.png
// module id = 581
// module chunks = 213534597649335